export default "__VITE_ASSET__BjC9jGNj__"